export const CONTEXT_MODES = [
  { value: 'paragraphs-only', text: 'Paragraphs Only' },
  { value: 'provisions-only', text: 'Provisions Only' },
  { value: 'provisions-surround', text: 'Provisions + Surrounding' },
  { value: 'provisions-paragraphs', text: 'Provisions + Paragraphs' },
  {
    value: 'provisions-surround-paragraphs',
    text: 'Provisions + Surrounding + Paragraphs',
  },
  { value: 'document-full', text: 'Full Document' },
]

export const PROVISIONS = [
  {
    provision_id: 6,
    name: 'Allowances',
    kira_field_id: 1532,
    kira_field_name: 'Allowances [Crunch]',
  },
  {
    provision_id: 9,
    name: 'Assurance of Owner Financing',
    kira_field_id: 946,
    kira_field_name: 'Assurance of Owner Financing [Crunch]',
  },
  {
    provision_id: 13,
    name: 'Attys Fees Costs Prevailing Party',
    kira_field_id: 887,
    kira_field_name: "Attorneys' Fees & Costs - Prevailing Party [Crunch]",
  },
  {
    provision_id: 14,
    name: 'Audit Rights Project Financials',
    kira_field_id: 900,
    kira_field_name: 'Audit Rights - Project Financials [Crunch]',
  },
  {
    provision_id: 183,
    name: 'Auto Liability - Insurance Compliance',
    kira_field_id: 1740,
    kira_field_name: 'Auto Liability - Insurance Compliance [Crunch]',
  },
  {
    provision_id: 24,
    name: 'Changes in the Work',
    kira_field_id: 1609,
    kira_field_name: 'Changes in the Work [Crunch]',
  },
  {
    provision_id: 25,
    name: 'Choice of Law Venue',
    kira_field_id: 888,
    kira_field_name: 'Choice of Law/Venue [Crunch]',
  },
  {
    provision_id: 27,
    name: 'Completion Milestones - Defined',
    kira_field_id: 1752,
    kira_field_name: 'Completion Milestones - Defined [Crunch]',
  },
  {
    provision_id: 31,
    name: 'Confidentiality Requirements',
    kira_field_id: 891,
    kira_field_name: 'Confidentiality Requirements [Crunch]',
  },
  {
    provision_id: 35,
    name: 'Contingency',
    kira_field_id: 897,
    kira_field_name: 'Contingency [Crunch]',
  },
  {
    provision_id: 36,
    name: 'Contractor Right to Stop Work',
    kira_field_id: 943,
    kira_field_name: 'Contractor Right to Stop Work [Crunch]',
  },
  {
    provision_id: 37,
    name: 'Contract Price Contract Sum GMP',
    kira_field_id: 884,
    kira_field_name: 'Contract Price, Contract Sum, GMP [Crunch]',
  },
  {
    provision_id: 43,
    name: 'Delays Compensation Remedies and Limitations',
    kira_field_id: 947,
    kira_field_name:
      'Delays: Compensation, Remedies and/or Limitations [Crunch]',
  },
  {
    provision_id: 47,
    name: 'Designated Representatives',
    kira_field_id: 1419,
    kira_field_name: 'Designated Representatives [Crunch]',
  },
  {
    provision_id: 48,
    name: 'Design Responsibility',
    kira_field_id: 949,
    kira_field_name: 'Design Responsibility [Crunch]',
  },
  {
    provision_id: 50,
    name: 'Dispute Resolution Mechanism',
    kira_field_id: 889,
    kira_field_name: 'Dispute Resolution Mechanism [Crunch]',
  },
  {
    provision_id: 52,
    name: 'Duration for Performance Contract Time',
    kira_field_id: 886,
    kira_field_name: 'Duration for Performance/Contract Time [Crunch]',
  },
  {
    provision_id: 67,
    name: 'Fiduciary Duties',
    kira_field_id: 1420,
    kira_field_name: 'Fiduciary Duties [Crunch]',
  },
  {
    provision_id: 68,
    name: 'Final Payment',
    kira_field_id: 1645,
    kira_field_name: 'Final Payment [Crunch]',
  },
  {
    provision_id: 190,
    name: 'General Liability - Insurance Compliance',
    kira_field_id: 1741,
    kira_field_name: 'General Liability - Insurance Compliance [Crunch]',
  },
  {
    provision_id: 74,
    name: 'Hazardous Materials Responsibilities',
    kira_field_id: 901,
    kira_field_name: 'Hazardous Materials - Responsibilities [Crunch]',
  },
  {
    provision_id: 77,
    name: 'Indemnification General Obligations',
    kira_field_id: 893,
    kira_field_name: 'Indemnification - General Obligations [Crunch]',
  },
  {
    provision_id: 80,
    name: 'Initial Technical Scheduling Requirements',
    kira_field_id: 1540,
    kira_field_name: 'Initial/Technical Scheduling Requirements [Crunch]',
  },
  {
    provision_id: 84,
    name: 'Insurance Requirements',
    kira_field_id: 1058,
    kira_field_name: 'Insurance Requirements [Crunch]',
  },
  {
    provision_id: 88,
    name: 'Jury Trial Waiver',
    kira_field_id: 890,
    kira_field_name: 'Jury Trial Waiver [Crunch]',
  },
  {
    provision_id: 115,
    name: 'Lien Rights Indemnity and Limitations',
    kira_field_id: 939,
    kira_field_name: 'Lien Rights: Indemnity and Limitations [Crunch]',
  },
  {
    provision_id: 118,
    name: 'Liquidated Damages',
    kira_field_id: 895,
    kira_field_name: 'Liquidated Damages [Crunch]',
  },
  {
    provision_id: 184,
    name: 'Liquor Liability - Insurance Compliance',
    kira_field_id: 1747,
    kira_field_name: 'Liquor Liability - Insurance Compliance [Crunch]',
  },
  {
    provision_id: 121,
    name: 'Mandatory Subcontract Flowdowns',
    kira_field_id: 1421,
    kira_field_name: 'Mandatory Subcontract Flowdowns [Crunch]',
  },
  {
    provision_id: 123,
    name: 'MWBE Requirements',
    kira_field_id: 1641,
    kira_field_name: 'MWBE Requirements [Crunch]',
  },
  {
    provision_id: 125,
    name: 'Notice of Claims When Must They Be Sent',
    kira_field_id: 950,
    kira_field_name: 'Notice of Claims - when must they be sent [Crunch]',
  },
  {
    provision_id: 126,
    name: 'Notices Where and How to Send',
    kira_field_id: 944,
    kira_field_name: 'Notices - Where and how to send [Crunch]',
  },
  {
    provision_id: 130,
    name: 'Order of Precedence',
    kira_field_id: 945,
    kira_field_name: 'Order of Precedence [Crunch]',
  },
  {
    provision_id: 182,
    name: 'Overall/Aggregate Caps on Liability',
    kira_field_id: 1748,
    kira_field_name: 'Overall/Aggregate Caps on Liability [Crunch]',
  },
  {
    provision_id: 132,
    name: 'Owner Directed Acceleration',
    kira_field_id: 1538,
    kira_field_name: 'Owner Directed Acceleration [Crunch]',
  },
  {
    provision_id: 137,
    name: 'Parties',
    kira_field_id: 892,
    kira_field_name: 'Parties [Crunch]',
  },
  {
    provision_id: 138,
    name: 'Pay if When Paid',
    kira_field_id: 1059,
    kira_field_name: 'Pay If/When Paid',
  },
  {
    provision_id: 140,
    name: 'Performance Payment Bonds',
    kira_field_id: 1533,
    kira_field_name: 'Performance/Payment Bonds [Crunch]',
  },
  {
    provision_id: 185,
    name: 'Pollution/Environment - Insurance Compliance',
    kira_field_id: 1743,
    kira_field_name: 'Pollution/Environment - Insurance Compliance [Crunch]',
  },
  {
    provision_id: 186,
    name: 'Professional Liability - Insurance Compliance',
    kira_field_id: 1746,
    kira_field_name: 'Professional Liability - Insurance Compliance [Crunch]',
  },
  {
    provision_id: 144,
    name: 'Progress Payments',
    kira_field_id: 1644,
    kira_field_name: 'Progress Payments [Crunch]',
  },
  {
    provision_id: 187,
    name: "Property/Builder's Risk - Insurance Compliance",
    kira_field_id: 1742,
    kira_field_name: "Property/Builder's Risk - Insurance Compliance [Crunch]",
  },
  {
    provision_id: 153,
    name: 'Retainage',
    kira_field_id: 2126,
    kira_field_name: 'Retainage [Crunch]',
  },
  {
    provision_id: 160,
    name: 'Savings',
    kira_field_id: 898,
    kira_field_name: 'Savings [Crunch]',
  },
  {
    provision_id: 167,
    name: 'Subsurface Conditions',
    kira_field_id: 938,
    kira_field_name: 'Subsurface Conditions [Crunch]',
  },
  {
    provision_id: 172,
    name: 'Terminations by Either Party',
    kira_field_id: 954,
    kira_field_name: 'Terminations - by either party [CRUNCH]',
  },
  {
    provision_id: 188,
    name: 'Umbrella/Excess Liability - Insurance Compliance',
    kira_field_id: 1744,
    kira_field_name:
      'Umbrella/Excess Liability - Insurance Compliance [Crunch]',
  },
  {
    provision_id: 175,
    name: 'Wage Requirements Prevailing Davis Bacon etc',
    kira_field_id: 1640,
    kira_field_name:
      'Wage Requirements (Prevailing, Davis-Bacon etc.) [Crunch]',
  },
  {
    provision_id: 177,
    name: 'Waiver of Subrogation',
    kira_field_id: 896,
    kira_field_name: 'Waiver of Subrogation [Crunch]',
  },
  {
    provision_id: 176,
    name: 'Waivers Limits of Consequential Damages',
    kira_field_id: 894,
    kira_field_name: 'Waivers/Limits of Consequential Damages [Crunch]',
  },
  {
    provision_id: 180,
    name: 'Warranty Obligations',
    kira_field_id: 940,
    kira_field_name: 'Warranty Obligations [Crunch]',
  },
  {
    provision_id: 181,
    name: 'Weather Days Defined Assumed',
    kira_field_id: 1539,
    kira_field_name: 'Weather Days Defined/Assumed [Crunch]',
  },
  {
    provision_id: 189,
    name: "Workers' Comp - Insurance Compliance",
    kira_field_id: 1745,
    kira_field_name: "Workers' Comp - Insurance Compliance [Crunch]",
  },
  {
    provision_id: 191,
    name: 'Force Majeure - Defined',
    kira_field_id: 1751,
    kira_field_name: 'Force Majeure - Defined [Crunch]',
  },
  {
    provision_id: 192,
    name: 'Material Price Escalation',
    kira_field_id: 2023,
    kira_field_name: 'Material Price Escalation [Crunch]',
  },
]
